/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const PostContentAreaAdaptiveQuestionsArbitraryR200ResponseQuestionAnswerTypeEnum = {
    SingularOr: 'singular_or',
    MultipleChoice: 'multiple_choice',
    MultipleAnswers: 'multiple_answers',
    Bucket: 'bucket',
    GraphLinear: 'graph_linear',
    GraphQuadratic: 'graph_quadratic',
    GraphLinearInequality: 'graph_linear_inequality',
    GraphExponential: 'graph_exponential',
    GraphScatterPoints: 'graph_scatter_points',
    FillInTheBlanks: 'fill_in_the_blanks'
};
/**
 * Check if a given object implements the PostContentAreaAdaptiveQuestionsArbitraryR200ResponseQuestion interface.
 */
export function instanceOfPostContentAreaAdaptiveQuestionsArbitraryR200ResponseQuestion(value) {
    if (!('answerType' in value) || value['answerType'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('isDeprecated' in value) || value['isDeprecated'] === undefined)
        return false;
    if (!('isDistrictAssessment' in value) || value['isDistrictAssessment'] === undefined)
        return false;
    if (!('stemId' in value) || value['stemId'] === undefined)
        return false;
    if (!('worth' in value) || value['worth'] === undefined)
        return false;
    return true;
}
export function PostContentAreaAdaptiveQuestionsArbitraryR200ResponseQuestionFromJSON(json) {
    return PostContentAreaAdaptiveQuestionsArbitraryR200ResponseQuestionFromJSONTyped(json, false);
}
export function PostContentAreaAdaptiveQuestionsArbitraryR200ResponseQuestionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'answerType': json['answerType'],
        'id': json['id'],
        'isDeprecated': json['isDeprecated'],
        'isDistrictAssessment': json['isDistrictAssessment'],
        'stemId': json['stemId'],
        'worth': json['worth'],
    };
}
export function PostContentAreaAdaptiveQuestionsArbitraryR200ResponseQuestionToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'answerType': value['answerType'],
        'id': value['id'],
        'isDeprecated': value['isDeprecated'],
        'isDistrictAssessment': value['isDistrictAssessment'],
        'stemId': value['stemId'],
        'worth': value['worth'],
    };
}
